<template>
    <div>
        <!-- <= 50 -->
        <div v-if="polylineData.blue && polylineData.blue.length">
            <l-polyline v-for="(seg, i) in polylineData.blue" :key="'b-' + i" :lat-lngs="seg" :color="'#0d6efd'"
                :opacity="0.65" :weight="6" />
        </div>
        <!-- 50 - 90 -->
        <div v-if="polylineData.orange && polylineData.orange.length">
            <l-polyline v-for="(seg, i) in polylineData.orange" :key="'o-' + i" :lat-lngs="seg" :color="'#ed8702'"
                :opacity="0.65" :weight="6" />
        </div>
        <!-- > 90 -->
        <div v-if="polylineData.red && polylineData.red.length">
            <l-polyline v-for="(seg, i) in polylineData.red" :key="'r-' + i" :lat-lngs="seg" :color="'#ed0202'"
                :opacity="0.65" :weight="6" />
        </div>
    </div>
    <!-- Pas de legend ici pour rester générique ; tes pages peuvent garder leur legend existante -->
</template>

<script>
import { LPolyline } from "@vue-leaflet/vue-leaflet";
export default {
    name: "SpeedPolylineLayer",
    components: { LPolyline },
    props: {
        polylineData: {
            type: Object,
            required: true, // { blue: number[][][], orange: number[][][], red: number[][][] }
        },
    },
};
</script>
